import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { invitesAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { useFarm } from '../../contexts/FarmContext';

const AcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const { user } = useAuth();
  const { loadFarms } = useFarm();
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [info, setInfo] = React.useState(null);
  const [accepting, setAccepting] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError('');
        const res = await invitesAPI.preview(token);
        setInfo(res.data || null);
      } catch (e) {
        setError(e.response?.data?.message || 'Invalid or expired invitation.');
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const onAccept = async () => {
    try {
      if (!user) {
        // Redirect to login and come back here afterwards
        const next = `/invite/accept?token=${encodeURIComponent(token)}`;
        navigate(`/login?next=${encodeURIComponent(next)}`);
        return;
      }
      setAccepting(true);
      await invitesAPI.accept(token);
      await loadFarms();
      navigate('/farms');
    } catch (e) {
      // If unauthorized, interceptor will redirect to /login automatically
      setError(e.response?.data?.message || 'Failed to accept invitation.');
    } finally {
      setAccepting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 max-w-lg w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Accept Invitation</h1>
        {loading ? (
          <div className="text-sm text-gray-600">Loading invitation...</div>
        ) : error ? (
          <div className="text-sm text-red-600">{error}</div>
        ) : info ? (
          <>
            <p className="text-sm text-gray-700">
              You are invited to join <span className="font-medium">{info.farm?.name || 'a farm'}</span> as{' '}
              <span className="font-medium capitalize">{info.role}</span>.
            </p>
            {!user && (
              <p className="text-xs text-gray-500 mt-2">
                You will be asked to log in before the invite can be accepted.
              </p>
            )}
            <div className="mt-4">
              <button
                onClick={onAccept}
                disabled={accepting}
                className="btn-primary"
              >
                {accepting ? 'Accepting…' : 'Accept Invite'}
              </button>
            </div>
          </>
        ) : (
          <div className="text-sm text-gray-600">Invitation not found.</div>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;


